import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Resume from "./components/Resume";

function App() {
  return (
    <div className="App">
     <Resume />
    </div>
  );
}

export default App;
